import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import ReduxPromise from 'redux-promise';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import reducers from './reducers';
import SignUp from './components/sessions/signUp';
import Login from './components/sessions/login';
import ForgotPassword from './components/sessions/forgotPassword';
import ResetPassword from './components/sessions/resetPassword';
import Schedule from './components/appointments/signup/schedule';
import AppointmentSignUp from './components/appointments/signup/signUp';
import MembershipError from './components/appointments/membershipError';
import ChangePassword from './components/sessions/changePassword';
import App from './components/app';
import PrivateRoute from './components/privateRoute';
import Alert from './components/alert';
import CONSTANTS from './constants';
import registerServiceWorker from './registerServiceWorker';

import './assets/styles/style.css';
import './assets/styles/utility.css';

const createStoreWithMiddleware = applyMiddleware(ReduxPromise, thunkMiddleware)(createStore);

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers)}>
    <BrowserRouter>
        <div>
	        <Alert />
            <Switch>
                <Route path={CONSTANTS.BASE_URL + "/sign_up"} component={SignUp} />
                <Route path={CONSTANTS.BASE_URL + "/login"} component={Login} />
                <Route path={CONSTANTS.BASE_URL + "/forgot_password"} component={ForgotPassword} />
                <Route path={CONSTANTS.BASE_URL + "/reset_password"} component={ResetPassword} />
                <Route path={CONSTANTS.BASE_URL + "/schedule"} component={Schedule} />
                <PrivateRoute exact path={CONSTANTS.BASE_URL + "/" } component={App} />
                <PrivateRoute exact path={CONSTANTS.BASE_URL + "/change_password"} component={ChangePassword} />
                <PrivateRoute exact path={CONSTANTS.BASE_URL + "/memberships"} component={App} contentComponent="memberships"/>
                <PrivateRoute path={CONSTANTS.BASE_URL + "/memberships/:id"} component={App} contentComponent="membership"/>
                <PrivateRoute exact path={CONSTANTS.BASE_URL + "/accounts"} component={App} contentComponent="accounts"/>
                <PrivateRoute path={CONSTANTS.BASE_URL + "/accounts/:id"} component={App} contentComponent="account"/>
                <PrivateRoute exact path={CONSTANTS.BASE_URL + "/appointments"} component={App} contentComponent="appointmentsList"/>
                <PrivateRoute path={CONSTANTS.BASE_URL + "/appointments/book"} component={App} contentComponent="bookAppointment"/>
                <PrivateRoute path={CONSTANTS.BASE_URL + "/appointments/:appointment_id/:activity_id/sign_up"} component={AppointmentSignUp} />
                <PrivateRoute path={CONSTANTS.BASE_URL + "/appointments/membershipError"} component={MembershipError} />
                <PrivateRoute path={CONSTANTS.BASE_URL + "/pos/sales"} component={App} contentComponent='sales' />
                <PrivateRoute path={CONSTANTS.BASE_URL + "/pos/orders/:order_id"} component={App} contentComponent='posOrder' />
                <PrivateRoute path={CONSTANTS.BASE_URL + "/history/"} component={App} contentComponent='history' />
            </Switch>
        </div>
    </BrowserRouter>
  </Provider>
  , document.getElementById('app-container'));

registerServiceWorker();
